var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"iron-door-apply-membership"}},[(_vm.acqRegisterUrl)?_c('a',{attrs:{"id":"iron-door-register-link","href":_vm.acqRegisterUrl}},[_vm._v(" "+_vm._s(_vm.$t("message.ironDoor.applyForMembership"))+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }